"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticInput = exports.StaticInputComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const text_1 = require("../text");
exports.StaticInputComponent = (0, react_1.forwardRef)((props, ref) => {
    const { value, placeholder, sx } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: [{ overflow: "auto", paddingTop: "4px", paddingBottom: "5px" }, ...(Array.isArray(sx) ? sx : [sx])], ref: ref, children: value || placeholder }));
});
const StaticInput = props => {
    const { InputLabelProps, InputProps, name, ...rest } = props;
    const value = (0, react_hook_form_1.useWatch)({ name });
    return ((0, jsx_runtime_1.jsx)(text_1.TextInput, { sx: { my: 1 }, name: name, value: value, InputLabelProps: {
            ...InputLabelProps,
            shrink: true,
        }, InputProps: {
            ...InputProps,
            inputComponent: exports.StaticInputComponent,
        }, ...rest }));
};
exports.StaticInput = StaticInput;
//# sourceMappingURL=index.js.map